import { createAction } from 'redux-act';

export const getAttendances = createAction();
export const receivedAttendances = createAction();

export const updateAttendance = createAction();
export const receivedAttendance = createAction();
